"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleOptionType = exports.MultipleOptionType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function cov_1w0l05je2f() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/type.js";
  var hash = "5ff1c09c7d9a88ef3fa1d7bfb7022cdb3a072214";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 32
        },
        end: {
          line: 7,
          column: 2
        }
      },
      "1": {
        start: {
          line: 9,
          column: 34
        },
        end: {
          line: 12,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5ff1c09c7d9a88ef3fa1d7bfb7022cdb3a072214"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1w0l05je2f = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1w0l05je2f();
var SingleOptionType = exports.SingleOptionType = (cov_1w0l05je2f().s[0]++, _propTypes.default.shape({
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired,
  icon: _propTypes.default.string
}));
var MultipleOptionType = exports.MultipleOptionType = (cov_1w0l05je2f().s[1]++, _propTypes.default.shape({
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  options: _propTypes.default.arrayOf(SingleOptionType)
}));